import { atom } from "jotai";
import { User, UserBrand } from "@/core/entities/user";

interface UserState {
  user: User | null;
  userBrands: UserBrand[] | null;
  isLoading: boolean;
  error: Error | null;
}

// Initial user state
const initialUserState: UserState = {
  user: null,
  userBrands: null,
  isLoading: true,
  error: null,
};

export const userAtom = atom<UserState>(initialUserState);

export const currentUserAtom = atom(get => get(userAtom).user);
export const userBrandsAtom = atom(get => get(userAtom).userBrands);
export const isUserLoadingAtom = atom(get => get(userAtom).isLoading);
export const userErrorAtom = atom(get => get(userAtom).error);
